































import { Anagrafica } from "@/data/models/anagrafica.model";
import { Page } from "yellowfin-ui-lib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class StpTable extends Vue {
  @Prop() data!: Anagrafica[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;

  firstload: boolean = true;

  @Prop() stpbase!: string;

  base = "";

  @Watch("data")
  onDataChange() {
    this.firstload = false;
  }

  onPageChange(page: number) {
    this.$emit("page", page);
  }

  mounted() {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const patha = location.pathname;
    let path =
      this.stpbase != undefined && this.stpbase != "" ? this.stpbase : patha;

    if (path.startsWith("/")) {
      path = path.substring(1);
    }

    if (params && (!this.stpbase || this.stpbase == "")) {
      this.base = "/" + path + "?" + uri + "&profileid=";
    } else {
      this.base = "/" + path + "?profileid=";
    }
  }
}
